var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#E3F3EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14c-5.2 0-9.5 1.2-9.5 2.7v22.6c0 1.5 4.3 2.7 9.5 2.7s9.5-1.2 9.5-2.7V16.7C37.5 15.2 33.2 14 28 14Z",
    fill: "#12B5A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17.2c1.8 1 5.2 1.7 9.5 1.7s7.7-.7 9.5-1.7v19.8c-1.8 1-5.2 1.7-9.5 1.7s-7.7-.7-9.5-1.7V17.2Z",
    fill: "#0B1739",
    opacity: 0.18
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.2c4.2 0 7.5.6 8.5 1.4-1 .8-4.3 1.4-8.5 1.4s-7.5-.6-8.5-1.4c1-.8 4.3-1.4 8.5-1.4Z",
    fill: "#fff",
    opacity: 0.55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36.8V19.4",
    stroke: "#0B1739",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22.5h12M22 26.5h12M22 30.5h8",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    opacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatEducation);
export default __webpack_public_path__ + "static/media/cat-education.92bb84ab9e3d60550db7e9dd3ff5a147.svg";
export { ForwardRef as ReactComponent };